<template>
  <page
    size="is-xlarge font-roboto"
    :title="pageTitle"
    headless
  >
    <div v-if="issue.data">
      <div
          class=""
      >
        <MagazineChart
            class="column mb-5"
            :height="60"
            :issue-id="issue.data.id"
        ></MagazineChart>
      </div>

      <div class="">
        <div class="box p-6">
          <div class="tabs ">
            <ul>
              <router-link tag="li" :to="`/magazine/magazine/issues/${issue.data.id}/stats/opens`">
                <a>Opens</a>
              </router-link>
              <router-link tag="li" :to="`/magazine/magazine/issues/${issue.data.id}/stats/downloads`">
                <a>Downloads</a>
              </router-link>
            </ul>
          </div>
          <div v-if="checkType('downloads')">
            <DownloadsList></DownloadsList>
          </div>
          <div v-else-if="checkType('opens')">
            <OpensList></OpensList>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import MagazineChart from "@/modules/admin/pages/dashboard/components/charts/Magazine2DownloadsAndViewsChart"
import DownloadsList from "@/modules/admin/pages/magazine/magazines/issues/component/DownloadsList";
import OpensList from "@/modules/admin/pages/magazine/magazines/issues/component/OpensList";

export default {
  components: {
    MagazineChart,
    DownloadsList,
    OpensList,
  },

  data() {
    return {
      issue: new window.RemoteData(`/admin/api/magazine/issues/${this.$route.params.id}`).load()
    };
  },

  computed: {
    pageTitle() {
      if (this.issue.data) {
        return this.issue.data.magazine.name + " / " + this.issue.data.title;
      }
      return "";
    }
  },

  methods: {
    checkActive(para) {
      return para === this.$route.params.type ? 'button mr-3 mb-3 is-danger' : 'button mr-3 mb-3 ';
    },
    checkType(para) {
      return para === this.$route.params.type;
    }
  }
};
</script>
